import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";
import moment from "moment";
import Paper from "@material-ui/core/Paper";

class FollowUpTypes extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: "Acompanhamentos",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      labels: ["Novos", "Stand-by", "Cancelados", "Admitidos"],
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  render() {
    return (
      <div class="ml-4 mt-4">
        {this.props.followUpTypes && (
          <Chart
            title={this.state.title}
            options={this.state.chartOptions}
            series={[
              {
                name: "Acompanhamentos",
                data: [
                  this.props.followUpTypes[0].aceites_com_nota_hj,
                  this.props.followUpTypes[0].aceites_colocados_em_standby,
                  this.props.followUpTypes[0].aceites_cancelados_hj,
                  this.props.followUpTypes[0].encaminhamentos_admitidos,
                ],
              },
            ]}
            type="bar"
            width="480"
            height="350"
          />
        )}
        <div class="h5 text-center mt-2 mr-4 pr-4 ml-4">
          <Paper elevation={5}>
            <div class="mb-4">
              {this.props.followUpTypes && (
                <span class="small p-4">
                  Acumulados desde sempre:{" "}
                  <span class="">
                    {" "}
                    {this.props.followUpTypes[0].aceites_acumulados_dsd_sp}{" "}
                  </span>
                </span>
              )}
            </div>
          </Paper>
        </div>
        <div class="subtitle-grafs mb-2 ml-4 mr-4">
          <u>Legenda</u>
        </div>
        <div class="subtitle-grafs ml-4 mr-4">
          <strong>Novos: </strong>Acompanhamentos com nota
          {this.props.filter_date_followup_types === null ||
          this.props.filter_date_followup_types ===
            moment().format("YYYY-MM-DD") ? (
            <span> de hoje</span>
          ) : (
            <span> no período de tempo definido no filtro</span>
          )}
        </div>
        <div class="subtitle-grafs ml-4 mr-4">
          <strong>Stand-by: </strong>Acompanhamentos colocados em stand-by
          {this.props.filter_date_followup_types === null ||
          this.props.filter_date_followup_types ===
            moment().format("YYYY-MM-DD") ? (
            <span> hoje</span>
          ) : (
            <span> no período de tempo definido no filtro</span>
          )}
        </div>
        <div class="subtitle-grafs ml-4 mr-4">
          <strong>Cancelados: </strong>Acompanhamentos cancelados
          {this.props.filter_date_followup_types === null ||
          this.props.filter_date_followup_types ===
            moment().format("YYYY-MM-DD") ? (
            <span> hoje</span>
          ) : (
            <span> no período de tempo definido no filtro</span>
          )}
        </div>
        <div class="subtitle-grafs ml-4 mr-4">
          <strong>Admitidos: </strong>Acompanhamentos admitidos posteriormente
        </div>
      </div>
    );
  }
}
export default FollowUpTypes;
